@if (assessment && (assessment.assessment || assessment.reason)) {
  <div
    class="simple-session-assessment"
    [class.fade-in]="fadeState === 'fade-in'"
    [class.visible]="fadeState === 'visible'"
    [class.fade-out]="fadeState === 'fade-out'"
    [style.background-color]="bgColor"
    (transitionend)="onTransitionEnd($event)"
  >
    <!-- 左側: assessment種別ラベル -->
    <div class="assessment-level">
      @if (displayAssessment?.assessment != null) {
        <span class="level-label">{{ displayAssessment?.assessment }}</span>
      }
    </div>

    <!-- 右側: reason -->
    @if (displayAssessment?.reason != null) {
      <div class="assessment-reason">
        {{ displayAssessment?.reason }}
      </div>
    }
  </div>
}
